import { PageContainer, SignupForm } from "../components";

const SignupPage = () => {
  return (
    <PageContainer>
      <SignupForm />
    </PageContainer>
  );
};

export default SignupPage;
